import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '@services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private sharedService: SharedService
  ) {
    this.initializeRouting();
  }
  ngOnInit() {
    const screen = this.getAttribute('Screen');
    this.sharedService.changeScreen(screen);
  }

  private initializeRouting(): void {
    const route = this.getAttribute('route');
    const token = this.getAttribute('token');
    const queryParamsJson = this.getAttribute('queryParams');
    localStorage.setItem('token', token);
    if (route) {
      const queryParams = queryParamsJson ? JSON.parse(queryParamsJson) : {};
      this.navigateToRoute(route, queryParams);
    }
  }

  private navigateToRoute(route: string, queryParams: any): void {
    if (Object.keys(queryParams).length > 0) {
      this.router.navigate([route], {
        queryParams: queryParams,
        queryParamsHandling: 'merge'
      });
    } else {
      this.router.navigate([route]);
    }
  }

  public getAttribute(attrName: string) {
    return this.elementRef.nativeElement.getAttribute(attrName);
  }
}
